import { createContext, useContext } from 'react';

/**
 * Provides the currently active preview role (or null when not previewing).
 * Shape: { id, label, description, scope: { show_pii, show_admin, ... } } | null
 */
export const PreviewRoleContext = createContext(null);

export function usePreviewRole() {
  return useContext(PreviewRoleContext);
}
